import { __decorate } from "tslib";
import { Component, Prop, Mixins } from 'vue-property-decorator';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import DiyPreviewDrawerMixin from '@/helpers/vue_mixins/v2/DiyPreviewDrawerMixin';
let FormHeader = class FormHeader extends Mixins(ViewportSizeMixin, DiyPreviewDrawerMixin) {
    styles() {
        return {
            'red--text': this.warning,
            'green--text': this.success,
            '-mobile': this.mobile,
        };
    }
};
__decorate([
    Prop({ type: String, required: true })
], FormHeader.prototype, "header", void 0);
__decorate([
    Prop({ type: String, default: null })
], FormHeader.prototype, "caption", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], FormHeader.prototype, "warning", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], FormHeader.prototype, "success", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], FormHeader.prototype, "mobile", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], FormHeader.prototype, "preview", void 0);
FormHeader = __decorate([
    Component
], FormHeader);
export default FormHeader;
